module.exports = __webpack_public_path__ + "static/media/xLargeFont.21b3c9dd.webp";